import gql from "graphql-tag";

import { Fragment, Report, ReportAnswer } from "../types";
import {
  TemplateQuestionFragment,
  TEMPLATE_QUESTION_FRAGMENT,
} from "./TemplateQuestion";
import { UserMinimalFragment, USER_MINIMAL_FRAGMENT } from "./User";

export const REPORT_ANSWER_FRAGMENT = gql`
  fragment ReportAnswerFragment on ReportAnswer {
    id
    templateQuestionId
    templateQuestion {
      ...TemplateQuestionFragment
    }
    type
    updatedAt
    isTalent
    reportId
    report {
      createdAt
      checkedAt
    }
    user {
      ...UserMinimalFragment
    }
    value
    timeSpent
    isEmpty
  }

  ${USER_MINIMAL_FRAGMENT}
  ${TEMPLATE_QUESTION_FRAGMENT}
`;

export type ReportAnswerFragment = Fragment<
  ReportAnswer,
  Omit<ReportAnswer, "templateQuestion" | "user" | "report"> & {
    user: UserMinimalFragment;
    templateQuestion: TemplateQuestionFragment;
    report: Pick<Report, 'createdAt' | 'checkedAt'>
  }
>;
